import cerbosLogo from "~/assets/cerbos-logo.png";

export function CerbosLogo({ className = "h-8 w-8" }: { className?: string }) {
  return <img src={cerbosLogo} alt="Cerbos logo" className={className} />;
}
